package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2024_07_05_Day_1() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We return to our heroes in Malus who had obtained their second shard (the anchor piece) of the Shield of Concar and gained the ability to Scry remaining shards scattered throughout Veldekar.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Last time our heroes were in Malus, they had purchased several magical items (Newgrowth 37). Annette’s Spyglass of Scrying was estimated to be completed on Newgrowth 44 and Dirk’s enchanted staff on Newgrowth 51. On Newgrowth 45, Dirk had used Sending to ask Sorla to hold the items until the heroes’ return to Malus. Dirk is a bit short on cash and receives a loan from Falorn. Caper buys a new magical weapon.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Next the heroes walk to the barracks to meet Lady Aventary and Sir Lorn Fogarth of The Peers and Malusian officials such as Sir Sorlon Dragstone and Voth Gardul. Tuesday summarizes recent events in a single breath as his comrades watch nervously, worrying that he may pass out before he completes the summary. Sir Lorn Fogarth tells the heroes that while they were gone, Ludwig Voss was spotted in the city (before the heroes killed him on Newgrowth 47).  The Malusians are grateful for our intel on Samuel Thardos, the Duke of Brij. The Peers decide that the shards of the Shield on Concar would probably be safer if our heroes held onto them, so they give the heroes the first shard, adding it to the bag of holding.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Summary of Shard locations:")
    }
    org.jetbrains.compose.web.dom.Ol {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Pentish - Lord Pent might be controlled by the demon Graz’zt.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Freeburg - will take some investigation since it’s a large / large population city (bigger than Malus)")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Girolion Forest - very remote in the far north. Wood elves.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("West of Seshiss - known for spices. Dangerous and remote.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Yassor - city is know for a university.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Freeman’s lake - frozen")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Vor’s Desert - north of Brij")
        }
    }
}
